import { convertToReadableString } from "utils"

export const trasncriptionTransformHelper = (response, args) => {
  const getCallTags = (callTags, summary) => {
    let tags = []
    callTags?.tags?.split(",")?.map(tag => {
      tags?.push(convertToReadableString(tag))
    })
    if (summary?.meeting?.status) {
      summary?.meeting?.status == "approved" ? tags?.push("Meeting Approved") : tags?.push("Meeting Rejected")
    }
    return tags
  }
  return args?.taskType === "management_meeting"
    ? { ...response, transcription: response?.transcription?.replace("\r", "")?.split("\n") }
    : {
        id: response?.phoneCallId,
        userName: response?.userData?.name,
        client: response?.clientData,
        callBy: response?.additionalData?.callBy,
        callType: response?.additionalData?.callType,
        tagShort: response?.additionalData?.PhoneCallTag?.abbreviation,
        tagColor: response?.additionalData?.PhoneCallTag?.style?.bgColor,
        tooltipTitle: response?.additionalData?.PhoneCallTag?.title,
        url: response?.additionalData?.url,
        date: response?.additionalData?.date,
        transcription: response?.transcription?.replace("\r", "")?.split("\n"),
        summary: {
          minutesOfMeeting: response?.summary?.minutesOfMeeting,
          description: response?.summary?.description,
          nextProposedTask: response?.summary?.nextProposedTask || "None",
          projectDiscussed: response?.summary?.projectDiscussed || "None",
          meeting: Object.keys(response?.summary?.meeting)?.length ? response?.summary?.meeting : null,
        },
        callTags: getCallTags(response?.callTags, response?.summary),
        clientInformation: Object.keys(response?.clientInformation?.client_information || {})?.length
          ? response?.clientInformation?.client_information
          : null,
        assessment: Object.keys(response?.assessment || {})?.length ? response?.assessment : null,
      }
}
